// import React, { useState, useEffect } from "react";
// import {
//   Download,
//   DollarSign,
//   Clock,
//   AlertCircle,
//   TrendingUp,
//   Eye,
//   Check,
// } from "lucide-react";

// const PaymentsManager = () => {
//   const [payments, setPayments] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     setTimeout(() => {
//       setPayments([
//         {
//           id: 1,
//           claimId: "CLM002",
//           recipient: "City Hospital",
//           amount: 450,
//           status: "completed",
//           processedDate: "2025-09-19",
//           bankDetails: "****-1234",
//         },
//         {
//           id: 2,
//           claimId: "CLM004",
//           recipient: "Downtown Clinic",
//           amount: 275,
//           status: "processing",
//           processedDate: null,
//           bankDetails: "****-5678",
//         },
//         {
//           id: 3,
//           claimId: "CLM005",
//           recipient: "Medical Center",
//           amount: 890,
//           status: "failed",
//           processedDate: "2025-09-17",
//           bankDetails: "****-9012",
//         },
//       ]);
//       setLoading(false);
//     }, 500);
//   }, []);

//   const getPaymentStatusColor = (status) => {
//     switch (status) {
//       case "completed":
//         return "bg-green-100 text-green-800";
//       case "processing":
//         return "bg-yellow-100 text-yellow-800";
//       case "failed":
//         return "bg-red-100 text-red-800";
//       default:
//         return "bg-gray-100 text-gray-800";
//     }
//   };

//   if (loading) return <div className="p-6">Loading payments...</div>;

//   return (
//     <div className="p-6">
//       <div className="flex justify-between items-center mb-6">
//         <div>
//           <h2 className="text-2xl font-bold text-gray-900">
//             Payment Management
//           </h2>
//           <p className="text-gray-600 mt-1">
//             Track and manage insurance claim payments
//           </p>
//         </div>

//         <button className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center">
//           <Download className="h-4 w-4 mr-2" />
//           Export Report
//         </button>
//       </div>

//       {/* Payment Stats */}
//       <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6">
//         <div className="bg-white rounded-xl shadow-sm border p-6">
//           <div className="flex items-center">
//             <div className="p-3 rounded-full bg-green-100">
//               <DollarSign className="h-6 w-6 text-green-600" />
//             </div>
//             <div className="ml-4">
//               <p className="text-sm font-medium text-gray-600">Total Paid</p>
//               <p className="text-2xl font-bold text-gray-900">$12,450</p>
//             </div>
//           </div>
//         </div>

//         <div className="bg-white rounded-xl shadow-sm border p-6">
//           <div className="flex items-center">
//             <div className="p-3 rounded-full bg-yellow-100">
//               <Clock className="h-6 w-6 text-yellow-600" />
//             </div>
//             <div className="ml-4">
//               <p className="text-sm font-medium text-gray-600">Processing</p>
//               <p className="text-2xl font-bold text-gray-900">$2,750</p>
//             </div>
//           </div>
//         </div>

//         <div className="bg-white rounded-xl shadow-sm border p-6">
//           <div className="flex items-center">
//             <div className="p-3 rounded-full bg-red-100">
//               <AlertCircle className="h-6 w-6 text-red-600" />
//             </div>
//             <div className="ml-4">
//               <p className="text-sm font-medium text-gray-600">Failed</p>
//               <p className="text-2xl font-bold text-gray-900">$890</p>
//             </div>
//           </div>
//         </div>

//         <div className="bg-white rounded-xl shadow-sm border p-6">
//           <div className="flex items-center">
//             <div className="p-3 rounded-full bg-blue-100">
//               <TrendingUp className="h-6 w-6 text-blue-600" />
//             </div>
//             <div className="ml-4">
//               <p className="text-sm font-medium text-gray-600">
//                 Avg Processing
//               </p>
//               <p className="text-2xl font-bold text-gray-900">2.3d</p>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Payments Table */}
//       <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
//         <div className="overflow-x-auto">
//           <table className="min-w-full divide-y divide-gray-200">
//             <thead className="bg-gray-50">
//               <tr>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   Payment ID
//                 </th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   Recipient
//                 </th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   Amount
//                 </th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   Bank Details
//                 </th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   Status
//                 </th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   Actions
//                 </th>
//               </tr>
//             </thead>
//             <tbody className="bg-white divide-y divide-gray-200">
//               {payments.map((payment) => (
//                 <tr key={payment?.id} className="hover:bg-gray-50">
//                   <td className="px-6 py-4 whitespace-nowrap">
//                     <div>
//                       <div className="text-sm font-medium text-gray-900">
//                         PAY-{payment?.id.toString().padStart(4, "0")}
//                       </div>
//                       <div className="text-sm text-gray-500">
//                         Claim: {payment?.claimId}
//                       </div>
//                     </div>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap">
//                     <div className="text-sm text-gray-900">
//                       {payment?.recipient}
//                     </div>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap">
//                     <div className="text-sm font-medium text-gray-900">
//                       ${payment?.amount}
//                     </div>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap">
//                     <div className="text-sm text-gray-900">
//                       {payment?.bankDetails}
//                     </div>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap">
//                     <span
//                       className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getPaymentStatusColor(
//                         payment?.status
//                       )}`}
//                     >
//                       {payment?.status}
//                     </span>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
//                     <div className="flex space-x-2">
//                       <button className="text-blue-600 hover:text-blue-900">
//                         <Eye className="h-4 w-4" />
//                       </button>
//                       {payment?.status === "failed" && (
//                         <button className="text-green-600 hover:text-green-900">
//                           <Check className="h-4 w-4" />
//                         </button>
//                       )}
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PaymentsManager;
import React, { useState, useEffect } from "react";
import {
  Download,
  DollarSign,
  Clock,
  AlertCircle,
  TrendingUp,
  Eye,
  Check,
} from "lucide-react";
import apiService from "../../services/apiService";

const PaymentsManager = () => {
  const [payments, setPayments] = useState([]);
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPayments();
    fetchStats();
  }, []);

  const fetchPayments = async () => {
    try {
      const res = await apiService.getPayments();
      console.log(res);
      setPayments(res?.data || []);
    } catch (error) {
      console.error("Error fetching payments:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchStats = async () => {
    try {
      const res = await apiService.getPaymentStats();
      setStats(res || {});
    } catch (error) {
      console.error("Error fetching stats:", error);
    }
  };

  const handleProcessPayment = async () => {
    try {
      const paymentData = {
        claim_id: 10,
        recipient_name: "Sunrise Health Clinic",
        amount: 1200.5,
        bank_details: {
          account_number: "****-1234",
          routing_number: "****-4321",
          bank_name: "Wells Fargo Bank",
        },
      };

      await apiService.processPayment(paymentData);
      fetchPayments(); // refresh list
    } catch (error) {
      console.error("Error processing payment:", error);
    }
  };

  const handleUpdateStatus = async (id, newStatus) => {
    try {
      const statusData = {
        status: newStatus,
        confirmation_number: "CONF" + Date.now(), // generate unique confirmation
      };

      await apiService.updatePaymentStatus(id, statusData);
      fetchPayments(); // refresh list
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const getPaymentStatusColor = (status) => {
    switch (status) {
      case "completed":
        return "bg-green-100 text-green-800";
      case "processing":
        return "bg-yellow-100 text-yellow-800";
      case "failed":
        return "bg-red-100 text-red-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  if (loading) return <div className="p-6">Loading payments...</div>;

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">
            Payment Management
          </h2>
          <p className="text-gray-600 mt-1">
            Track and manage insurance claim payments
          </p>
        </div>

        <div className="flex gap-2">
          <button
            onClick={handleProcessPayment}
            className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700"
          >
            + New Payment
          </button>
          <button className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center">
            <Download className="h-4 w-4 mr-2" />
            Export Report
          </button>
        </div>
      </div>

      {/* Payment Stats */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6">
        <div className="bg-white rounded-xl shadow-sm border p-6">
          <div className="flex items-center">
            <div className="p-3 rounded-full bg-green-100">
              <DollarSign className="h-6 w-6 text-green-600" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">Total Paid</p>
              <p className="text-2xl font-bold text-gray-900">
                ${stats.total_paid || 0}
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border p-6">
          <div className="flex items-center">
            <div className="p-3 rounded-full bg-yellow-100">
              <Clock className="h-6 w-6 text-yellow-600" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">Processing</p>
              <p className="text-2xl font-bold text-gray-900">
                ${stats.processing || 0}
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border p-6">
          <div className="flex items-center">
            <div className="p-3 rounded-full bg-red-100">
              <AlertCircle className="h-6 w-6 text-red-600" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">Failed</p>
              <p className="text-2xl font-bold text-gray-900">
                ${stats.failed || 0}
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border p-6">
          <div className="flex items-center">
            <div className="p-3 rounded-full bg-blue-100">
              <TrendingUp className="h-6 w-6 text-blue-600" />
            </div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">
                Avg Processing
              </p>
              <p className="text-2xl font-bold text-gray-900">
                {stats.avg_processing || "0d"}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Payments Table */}
      <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                  Payment ID
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                  Recipient
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                  Amount
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                  Bank Details
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {payments?.map((payment) => (
                <tr key={payment?.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div>
                      <div className="text-sm font-medium text-gray-900">
                        PAY-{payment?.id.toString().padStart(4, "0")}
                      </div>
                      <div className="text-sm text-gray-500">
                        Claim: {payment?.claim_id}
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900">
                      {payment?.recipient_name}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm font-medium text-gray-900">
                      ${payment?.amount}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900">
                      {payment?.bank_details?.account_number}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span
                      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getPaymentStatusColor(
                        payment?.status
                      )}`}
                    >
                      {payment?.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <div className="flex space-x-2">
                      <button className="text-blue-600 hover:text-blue-900">
                        <Eye className="h-4 w-4" />
                      </button>
                      {payment?.status === "failed" && (
                        <button
                          onClick={() =>
                            handleUpdateStatus(payment?.id, "completed")
                          }
                          className="text-green-600 hover:text-green-900"
                        >
                          <Check className="h-4 w-4" />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PaymentsManager;
